import { find, isUndefined } from "lodash"
import { useEffect, useState } from "react"
import { DefaultAutocompleteType } from "./DefaultAutocompleteType"
import { ReactQueryAutocomplete, ReactQueryAutocompleteProps } from "./ReactQueryAutocomplete"

export interface DefaultAutocompleteProps<T extends DefaultAutocompleteType>
    extends Omit<InternalDefaultAutocompleteProps<T>, "query" | "displayFieldName"> {
}

export interface InternalDefaultAutocompleteProps<T extends DefaultAutocompleteType>
    extends Omit<ReactQueryAutocompleteProps<T, false>, "onChange"> {
    onChange: (v: T | null) => void,
    selection: T | null,
    initialSelectedId?: number | string,
}

export const DefaultAutocomplete = <T extends DefaultAutocompleteType>(props: InternalDefaultAutocompleteProps<T>) => {

    const { selection, onChange, initialSelectedId, ...fwdProps } = props

    const [currentSelection, setCurrentSelection] = useState(selection);

    const [isInitialized, setIsInitialized] = useState(false);

    const initialSelection = find(props.query.data, (d: T) => d.id === initialSelectedId)

    useEffect(
        () => {

            // initialized
            if (isInitialized) {
                setCurrentSelection(selection);
                return;
            }

            // if autocomplete data are not available, no need to go further
            if (props.query.data.length === 0)
                return;

            // not initialized and initial selection
            if (!isUndefined(initialSelection)) {
                setCurrentSelection(initialSelection)
                onChange(initialSelection)
            }

            // set initialized
            setIsInitialized(true);
        },
        [initialSelection, isInitialized, onChange, props.query.data.length, selection]
    )

    return (
        <ReactQueryAutocomplete

            {...fwdProps}

            onChange={(e, v) => {
                setCurrentSelection(v)
                onChange(v)
            }}

            value={currentSelection}
        />
    )
}
